
RC = (function() {

	var dxCount;
	var dxChangeCount;
	var refer;
	var userCount;
	var phone;
	var service;


    return {

        getDxCount: function() {
            return this.dxCount; 
        },
        getDxChangeCount: function() {
            return this.dxChangeCount; 
        },  
        getRefer: function() {
            return this.refer; 
        },   
        getUserCount : function(){
        	return this.userCount;
        },
        getPhone : function(){
        	return this.phone;
        },
        getService : function(){
        	return this.service;
        } 
        

            
    };
     

})();
/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

var SUBKIT = (function() {

	var header;
	var token;


    return {

        getHeader: function() {
            return this.header; // this function can access my_var
        },
        getToken: function() {
            return this.token; // this function can access my_var
        }
            
    };
     

})();




$(document).ready(function() {

    SUBKIT.token = $("meta[name='_csrf']").attr("content");
    SUBKIT.header = $("meta[name='_csrf_header']").attr("content");

	$.ajaxSetup({
		  beforeSend: function(xhr) {
	        xhr.setRequestHeader(SUBKIT.getHeader(), SUBKIT.getToken());
	    	}
	});	
;
    
    var message = getUrlParameter('message');
	
	if (message){
		showMessage(message);

	}
	
	$('#signButton').click ( function (e) {
		if ($('#requireValidation').val() === "true") {
			if ($('#edit-patient-form').valid() & $('#edit-claim-form').valid() & $('#authorise-form').valid()){ 
				$('#signModal').modal('show');
			} 
		} else if ($('#authorise-form').valid()){
			$('#signModal').modal('show');
		}
	})
	

	



	if ( $('canvas').length){
		
		var canvas = document.querySelector("canvas");
		
		var parentWidth = $('.modal-dialog').css( "max-width" );
		var widthCanvas = parseInt(parentWidth) - 20;
		canvas.setAttribute("width", widthCanvas );
	var signaturePad = new SignaturePad(canvas, {
	  // It's Necessary to use an opaque color when saving image as JPEG;
	  // this option can be omitted if only saving as PNG or SVG
	  backgroundColor: 'rgb(255, 255, 255)'
	});	
	
	signaturePad.clear();
//	 nzbnSearch();
	}




	
	$('.submitClaimOpen').click(function(){
		
		if ($('#requireValidation').val() === "true") {
			if ($('#edit-patient-form').valid() & $('#edit-claim-form').valid() & $('#authorise-form').valid()){ 
				save_to_editted_open();
			} 
		} else if ($('#authorise-form').valid() ) {
			save_to_editted_open();
		}
		
		

	});	
	$('.savePendingClaim').click(function(){
		
		save_to_editted_open(true);
		
		

	});	
	$('#submitClaimExisting').click(function(){
		
		save_to_editted_open();
		
		

	});		
	
	
	

	
	$('#subExportOpen').click(function (){

		  if (signaturePad.isEmpty()) {
			  
			    msg_time("alert-danger" , "Signature required" , "Please provide a signature first.");
			  } else {
					if ($('#authorise-form').valid()){
			    var dataURL = signaturePad.toDataURL("image/jpeg");
			    var blob = dataURLToBlob(dataURL);
				save_to_editted_signature_open(blob);
					}
			   
			  }

	});
	
	$('#client-form-cancel').click(function (){
	
	 	if ( $('#client-view-only').length ){ 
		    if ('referrer' in document) {
		        window.location = document.referrer;
		        /* OR */
		        //location.replace(document.referrer);
		    } else {
		        window.history.back();
		    } 
	    } else {
	    	cancel_form();
	    }	
	});
	

	

	

    
//    var datepicker = $.fn.datepicker.noConflict(); // return $.fn.datepicker to previously assigned value
//    $.fn.bootstrapDP = datepicker;                 // give $().bootstrapDP the bootstrap-datepicker functionality
//
    $('#accidentDateText').datepicker({
    	maxDate: '0',
        dateFormat:"dd/mm/yy",
        altField: "#accidentDate",
        altFormat: "yy-mm-dd"
     });
    
	$('#clear').click( function (event) {
		  signaturePad.clear();
		});
	
	$('#undo').click(function (event) {
		  var data = signaturePad.toData();

		  if (data) {
		    data.pop(); // remove the last dot or line
		    signaturePad.fromData(data);
		  }
		});
	


//	$('#save-jpg').click(function (event) {
//
//			});
	
	if ( $('#sport').length ){
    $("#sport").autocomplete({
        minLength: 3,
        delay: 500,

        source: function(request, response) {
            $.getJSON("/sports", request, function(result) {
                response($.map(result, function(item) {
                    return {
                        // following property gets displayed in drop down
                        label: item.codeDescription,
                        // following property gets entered in the textbox
                        value: item.codeDescription,
                        id: item.id
                    };
                }));
            });
        },
        change: function(event, ui) {
            if (ui.item == null) {
                $('#sportid').val('');
                $('#sport').val('');
                $('#sport').focus();
            }
        },
        //define select handler
        select: function(event, ui) {
            if (ui.item) {
    
                $('#sportid').val(ui.item.id);
            


            }
        }
    });
	}

	

	
	
	
	$('#authorise-form').validate({
    	errorClass: "is-invalid",
        focusInvalid: true,
        rules: {

        
        	accTerms: {
                required: true

            }

        },



        invalidHandler: function(form, validator) {

            if (!validator.numberOfInvalids())
                return;

            $('.feedback').append('<div class="alert alert-danger alert-dismissible fade show" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> You need to tick the authorisation to submit the form</div>');
            setTimeout(function() {
                $(".alert-dismissible").alert('close');
            }, 6000);

        },  
        

        errorElement: "div",
        errorPlacement: function(error, element) {
            // Add the `help-block` class to the error element
            error.addClass("form-control-feedback");

            if ($(element).prop("type") === "checkbox") {
                error.insertAfter($(element));
            } 
            
            
        },
        highlight: function(element, errorClass, validClass) {
        	 $(element).addClass(errorClass);
        	 $(element).parents(".form-group").addClass("text-danger");

            
        	
            
        },
        unhighlight: function(element, errorClass, validClass) {
   
        	$(element).removeClass(errorClass);

            $(element).parents(".form-group").removeClass("text-danger");


        }
              

    });
	
    jQuery.validator.addMethod("minDate", function(value, element) {
        var now = new Date();
        var myDate = new Date(value);
        myDate.setHours(0);
        return this.optional(element) || myDate <= now;
    });
	
    $('#edit-claim-form').validate({
        errorClass: "is-invalid text-danger",
        focusInvalid: false,
        rules: {
            ignore: ".ignore",


            accidentDateText: {
                required: true
            },

            causeOfAccident: {
                required: true
            },
            "location[id]": {
                required: true
            },
            "scene[id]": {
                required: true
            },
            involvesVehicle: {
                required: true
            },
            workInjury: {
                required: true
            },
            sportingInjury: {
                required: true
            },
            sportText: {
                required: '#radioSportingTrue:checked'
            }

        },

        messages: {

            accidentDate: {
                required: "Please supply a date of injury",
                minlength: "Please enter a valid date",
                minDate: "Date must be today or earlier"
            }

        },

        invalidHandler: function (form, validator) {

            if (!validator.numberOfInvalids())
                return;
            $('.feedback').append('<div class="alert alert-danger alert-dismissible fade show" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button> <h4 class="text-danger" >Claim Form Errors</h4> Please fix errors and resubmit</div>');
            setTimeout(function () {
                $(".alert-dismissible").alert('close');
            }, 6000);

        },

        errorElement: "div",
        errorPlacement: function (error, element) {

            error.addClass("form-control-feedback");
            error.insertAfter($('.save-submit'));
            error.insertAfter($('#submit-error'));
            $('#claimEditModal #submit-error').text(error);
            $('#submit-error').append("Please correct errors above");
            if ($(element).prop("type") === "checkbox") {
                error.insertAfter($(element).parent("label"));
            } else if ($(element).prop("type") === "radio") {

                error.insertAfter($(element).closest('div').next('div'));
            } else {
                error.insertAfter($(element));
            }
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass(errorClass);
            //        	 $('.save-and-submit').addClass("btn-danger");
            if ($(element).hasClass('code-element')) {
                $(element).parents(".code-row").addClass("text-danger");
            } else if ($(element).prop("type") === "radio") {
                $(element).parents(".form-group").addClass("text-danger");
                //        		 $(element).closest('label').addClass("btn-outline-danger");
                //        		 $(element).closest('label').next().addClass("btn-outline-danger");
            } else {

                $(element).parents(".form-group").addClass("text-danger");
            }


        },
        unhighlight: function (element, errorClass, validClass) {

            $(element).removeClass(errorClass);
            //        	 $('.save-and-submit').removeClass("btn-danger");
            $(element).parents(".form-group").removeClass("text-danger");
            $(element).parents(".code-row").removeClass("text-danger");
            $('#submit-error').empty();
            //            $(element).parent().find('label').removeClass("btn-outline-danger");
        }


    });
	
	setTimeout(function() { 
		homeMessage();
	}, 2000);

	$('#previouslyRegisteredShow').change(function(){
		if ($(this).prop("checked")){
			$('#previouslyRegistered').val('true');
		} else {
			$('#previouslyRegistered').val('false');
		}
	});

});


function homeMessage(){
    var urlStatus = getUrlParameter('status');

	if (urlStatus){
		var client = getUrlParameter('client');
		var deviceName = getUrlParameter('device');
		var to =  getUrlParameter('to');
        var message = { status : 'status',
        		msg : 'msg',
        		from : 'from',
        		sentTime : 'sentTime',
        		to : 'to'
        };
     	message.from = deviceName;
     	message.sentTime = Date.now();
     	message.to = to;
		if (urlStatus === "cancelled"){


	     	message.msg = client+" has cancelled filling out form on " + deviceName;
	     	message.status = "device-cancelled";

	     
		} else if (urlStatus === "completed"){
			message.msg =  client+" has submitted claim form from " + deviceName;
			message.status = "device-completed";
		}
		sendMessage(message);
		
		updateURL();
	} 
}

function cancel_form() {
	 var to = $('#userTo').val();//getUrlParameter('from');
	// var mgmtSystemId = $('#mgmtSystemId').val();
	 var deviceName = $('#deviceName').val();
	
	var patientData = $('form#edit-patient-form').serializeJSON({ useIntKeysAsArrayIndex: true});

	
 $.ajax({
     type: "GET",
     url: "/client/cancel-form/"+$('#devicePatientPendingId').val()
 })
   .done ( function(data) {

     	window.location.href = '/client/client-home?status=cancelled&message=Form submission cancelled&client='+patientData.firstName+" "+patientData.surname+'&device='+deviceName+'&to='+to;

     })
	   .fail(function(jqXHR) { 
	  	
		   window.location = '/client/client-home';
	    	});	 
}

function save_to_editted_open(saveOnly) {
	
	var completed = true;
	if(saveOnly){
		completed = false;
	}

	var clientPendingId = $('#clientFormPending').val();
	
	var patientClaimRequest = create_patient_claim_request();
	
	url = "";
	if (clientPendingId){
		url = "/client-open/save-client-edit-open/"+clientPendingId+"/"+completed+"/"+$('#urlToken').val()
	} else {
		url = "/client-open/save-client-edit-open-link/"+$('#urlToken').val()
	}

	
  $.ajax({
      type: "POST",
      url: url,
      contentType: "application/json",
      data: JSON.stringify(patientClaimRequest)
  })
    .done ( function(clinic) {
 	   if (saveOnly){
 		  msg_time("alert-success", "Form Saved" , "Please complete and submit the form when you are able to.");

		
	   } else {
		   msg_time("alert-success", "Submitted" , "Your form has been submitted");
			window.location.href = '/client-form-completed?clinic='+clinic;

   	   }

      })
	   .fail(function(jqXHR) { 
	  	
		    if (jqXHR.status == 401 ) {
		    	msg_non_time("alert-danger" , "Please Update" , 'A new version of this page exists, <a href="javascript:window.location.reload(true)">Update now</a>')
		    } else if (jqXHR.status == 403 ) {
		    	msg_non_time("alert-danger" , "Permission Error" , 'You do not have sufficient permissions for this action');
		    } else {
		    	msg_non_time("alert-danger", "Errors!", jqXHR.responseJSON.message );

		    }
	    });	 
}



function create_patient_claim_request(){
	

	var patientData = $('form#edit-patient-form').serializeJSON({ useIntKeysAsArrayIndex: true});
	var claimData = $('form#edit-claim-form').serializeJSON({ useIntKeysAsArrayIndex: true});



	patientData = edit_patient_json(patientData);
	var patientClaimRequest =  {
		patient : patientData,
		claimDto : claimData
	};
	return patientClaimRequest;
}


function save_to_editted_signature_open(blob) {

	var patientClaimRequest = create_patient_claim_request();
	
	var formData = new FormData();
	formData.append("signature", blob, "signature.jpg");
	formData.append('patientClaimRequest', new Blob([JSON.stringify(patientClaimRequest)], {
       type: "application/json"
   }));	


	var clientPendingId = $('#clientFormPending').val();

	var patientClaimRequest = create_patient_claim_request();
	url = "";
	if (clientPendingId){
		url = "/client-open/save-client-signature-edit-open/"+clientPendingId+"/"+$('#urlToken').val();
	} else {
		url = "/client-open/save-client-signature-edit-open-link/"+$('#urlToken').val();
	}
  $.ajax({
      type: "POST",
      url: url,
      contentType: "application/json",
      data: formData,
      processData: false, 
      contentType: false
  })
       .done ( function(data) {
		   msg_time("alert-success", "Submitted" , "Your form has been submitted");
			window.location.href = '/client-form-completed?clinic='+data;
       })
 	   .fail(function(jqXHR) { 
 		  	
 		    if (jqXHR.status == 401 ) {
 		    	msg_non_time("alert-danger" , "Please Update" , 'A new version of this page exists, <a href="javascript:window.location.reload(true)">Update now</a>')
 		    } else if (jqXHR.status == 403 ) {
 		    	msg_non_time("alert-danger" , "Permission Error" , 'You do not have sufficient permissions for this action');
 		    } else {
 		    	msg_non_time("alert-danger", "Errors!", jqXHR.responseJSON.message );

 		    }
  	});	 
}


//Adjust canvas coordinate space taking into account pixel ratio,
//to make it look crisp on mobile devices.
//This also causes canvas to be cleared.
function resizeCanvas(canvas, signaturePad) {
 // When zoomed out to less than 100%, for some very strange reason,
 // some browsers report devicePixelRatio as less than 1
 // and only part of the canvas is cleared then.
 var ratio =  Math.max(window.devicePixelRatio || 1, 1);


 // This part causes the canvas to be cleared
 canvas.width = canvas.offsetWidth * ratio;
 canvas.height = canvas.offsetHeight * ratio;
 canvas.getContext("2d").scale(ratio, ratio);

 // This library does not listen for canvas changes, so after the canvas is automatically
 // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
 // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
 // that the state of this library is consistent with visual state of the canvas, you
 // have to clear it manually.
 signaturePad.clear();
}

function returnHome(){
	window.location.href = "/client/client-home";
}



//One could simply use Canvas#toBlob method instead, but it's just to show
//that it can be done using result of SignaturePad#toDataURL.
function dataURLToBlob(dataURL) {
 // Code taken from https://github.com/ebidel/filer.js
 var parts = dataURL.split(';base64,');
 var contentType = parts[0].split(":")[1];
 var raw = window.atob(parts[1]);
 var rawLength = raw.length;
 var uInt8Array = new Uint8Array(rawLength);

 for (var i = 0; i < rawLength; ++i) {
   uInt8Array[i] = raw.charCodeAt(i);
 }

 return new Blob([uInt8Array], { type: contentType });
}	








function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
    }
}
}




function  msg_non_time  (alertType, heading, message){
	var hText = "";
	if (alertType === "alert-danger"){
		hText = "class='alert-danger'";
	} else if (alertType === "alert-warning"){
		hText = "class='alert-warning'";
	} else if (alertType === "alert-success") {
		hText = "class='alert-success'";
	} else if (alertType === "alert-info") {
		hText = "class='alert-info'";
	}
	$('.feedback').append('<div class="alert '+alertType+' alert-dismissible fade show" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> <h4 '+hText+'>'+heading+'</h4> '+message+' </div>');
//  setTimeout(function() {
//      $(".alert-dismissible").alert('close');
//  }, 8000);
	
}

function  msg_time  (alertType, heading, message){
	var hText = "";
	if (alertType === "alert-danger"){
		hText = "class='alert-danger'";
	} else if (alertType === "alert-warning"){
		hText = "class='alert-warning'";
	} else if (alertType === "alert-success") {
		hText = "class='alert-success'";
	} else if (alertType === "alert-info") {
		hText = "class='alert-info'";
	}
	$('.feedback').append('<div class="alert '+alertType+' alert-dismissible fade show" role="alert"> <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> <h4 '+hText+'>'+heading+'</h4> '+message+' </div>');
  setTimeout(function() {
      $(".alert-dismissible").alert('close');
  }, 8000);
	
}

function updateURL() {

    if (history.pushState) {

        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '/';
        window.history.pushState({path:newurl},'',newurl);
        window.history.replaceState(null, null, '');
    }
  }
